import React from 'react';
import PropTypes from 'prop-types';

import UTModal from '../../../../../../components/UTModal';
import { message } from '../../../../../../../utils/stringUtils';
import { accountPropTypes } from '../../../../../../../redux/accountHandlers';

import QueryModal from './layout';

function QueryModalContainer(props) {
  const acceptButton = !props.socialRateStatus &&
    !props.socialRateLoading && {
      text: message('SocialRate:query'),
      onPress: props.handleSubmit,
      disabled: props.invalid && props.submitFailed
    };

  return (
    <UTModal
      isOpen={props.modalIsOpen}
      onRequestClose={props.closeModal}
      cancelButton={
        !props.socialRateLoading && {
          text: message('Commons:back'),
          onPress: props.closeModal
        }
      }
      acceptButton={acceptButton}
      contentLabel={message('Accounts:addAccount')}
      title={message('SocialRate:socialRateQuery')}
    >
      <QueryModal
        loading={props.socialRateLoading}
        onSubmit={props.handleSocialRateQuery}
        socialRateStatus={props.socialRateStatus}
        userAccounts={props.userAccounts}
        isPublicRequest={props.isPublicRequest}
      />
    </UTModal>
  );
}

QueryModalContainer.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleSocialRateQuery: PropTypes.func.isRequired,
  socialRateLoading: PropTypes.bool,
  socialRateStatus: PropTypes.shape({
    address: PropTypes.string,
    message: PropTypes.string,
    social_rate: PropTypes.bool,
    clientNumber: PropTypes.number
  }),
  invalid: PropTypes.bool,
  submitFailed: PropTypes.bool,
  userAccounts: accountPropTypes,
  isPublicRequest: PropTypes.bool
};

export default QueryModalContainer;
